// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Backdrop styles */
.tmatrix-modal-backdrop-v {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    display: flex;
    justify-content: center; /* Horizontally center the modal */
    align-items: center; /* Vertically center the modal */
    z-index: 9999; /* Ensure it appears on top of all other elements */
}

/* Modal container styles */
.tmatrix-modal-content-v {
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 20px;
    max-width: 500px;
    width: 90%; /* For responsive width */
    position: relative;
    animation: fadeIn 0.3s ease-in-out; /* Add subtle animation */
}

/* Animation for the modal */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: scale(0.9);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

/* Centered headings */
.tmatrix-modal-content-v h4 {
    font-size: 1.5em;
    margin-bottom: 10px;
    color: #333;
    text-align: center;
    font-weight: bold;
}

.tmatrix-modal-content-v h5 {
    font-size: 1em;
    margin-bottom: 20px;
    color: #555;
    text-align: center;
}

/* Information container */
.info-container-v {
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 10px;
    margin-bottom: 15px;
    word-wrap: break-word; /* Ensure long text wraps */
    overflow-wrap: break-word;
}

/* Error message */
.info-container-v .error-message {
    color: #b9a190;
    background-color: #f8d7da;
    padding: 8px;
    border-radius: 6px;
    border: 1px solid #f5c6cb;
    margin-top: 10px;
    font-size: 0.95em;
}

/* Buttons */
.btn-upload-v, .button-close-v {
    display: block;
    background-color: #b9a190;
    color: #fff;
    font-size: 1em;
    padding: 10px 15px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 20px;
    width: 100%;
    text-align: center;
    transition: background-color 0.3s;
}

.btn-upload-v:hover {
    background-color: #b9a190;
}

.button-close-v {
    background-color: #b9a190;
    margin-top: 10px;
}

.button-close-v:hover {
    background-color: #b9a190;
}

/* Comment box container */
.table-container-comment-v {
    padding: 20px;
    background-color: #fefefe;
    border: 1px solid #ddd;
    border-radius: 8px;
    text-align: center; /* Center-align text */
}

/* Responsive design */
@media (max-width: 600px) {
    .tmatrix-modal-content-v {
        padding: 15px;
    }

    .btn-upload-v, .button-close-v {
        font-size: 0.9em;
        padding: 8px 12px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/MainSection/UploadComponents/MessageValidationBox.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC,EAAE,gCAAgC;IACtE,aAAa;IACb,uBAAuB,EAAE,kCAAkC;IAC3D,mBAAmB,EAAE,gCAAgC;IACrD,aAAa,EAAE,mDAAmD;AACtE;;AAEA,2BAA2B;AAC3B;IACI,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,gBAAgB;IAChB,UAAU,EAAE,yBAAyB;IACrC,kBAAkB;IAClB,kCAAkC,EAAE,yBAAyB;AACjE;;AAEA,4BAA4B;AAC5B;IACI;QACI,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA,sBAAsB;AACtB;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA,0BAA0B;AAC1B;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,qBAAqB,EAAE,2BAA2B;IAClD,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,YAAY;AACZ;IACI,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB,EAAE,sBAAsB;AAC9C;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;AACJ","sourcesContent":["/* Backdrop styles */\n.tmatrix-modal-backdrop-v {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\n    display: flex;\n    justify-content: center; /* Horizontally center the modal */\n    align-items: center; /* Vertically center the modal */\n    z-index: 9999; /* Ensure it appears on top of all other elements */\n}\n\n/* Modal container styles */\n.tmatrix-modal-content-v {\n    background-color: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n    max-width: 500px;\n    width: 90%; /* For responsive width */\n    position: relative;\n    animation: fadeIn 0.3s ease-in-out; /* Add subtle animation */\n}\n\n/* Animation for the modal */\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: scale(0.9);\n    }\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n/* Centered headings */\n.tmatrix-modal-content-v h4 {\n    font-size: 1.5em;\n    margin-bottom: 10px;\n    color: #333;\n    text-align: center;\n    font-weight: bold;\n}\n\n.tmatrix-modal-content-v h5 {\n    font-size: 1em;\n    margin-bottom: 20px;\n    color: #555;\n    text-align: center;\n}\n\n/* Information container */\n.info-container-v {\n    background-color: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    padding: 10px;\n    margin-bottom: 15px;\n    word-wrap: break-word; /* Ensure long text wraps */\n    overflow-wrap: break-word;\n}\n\n/* Error message */\n.info-container-v .error-message {\n    color: #b9a190;\n    background-color: #f8d7da;\n    padding: 8px;\n    border-radius: 6px;\n    border: 1px solid #f5c6cb;\n    margin-top: 10px;\n    font-size: 0.95em;\n}\n\n/* Buttons */\n.btn-upload-v, .button-close-v {\n    display: block;\n    background-color: #b9a190;\n    color: #fff;\n    font-size: 1em;\n    padding: 10px 15px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-top: 20px;\n    width: 100%;\n    text-align: center;\n    transition: background-color 0.3s;\n}\n\n.btn-upload-v:hover {\n    background-color: #b9a190;\n}\n\n.button-close-v {\n    background-color: #b9a190;\n    margin-top: 10px;\n}\n\n.button-close-v:hover {\n    background-color: #b9a190;\n}\n\n/* Comment box container */\n.table-container-comment-v {\n    padding: 20px;\n    background-color: #fefefe;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    text-align: center; /* Center-align text */\n}\n\n/* Responsive design */\n@media (max-width: 600px) {\n    .tmatrix-modal-content-v {\n        padding: 15px;\n    }\n\n    .btn-upload-v, .button-close-v {\n        font-size: 0.9em;\n        padding: 8px 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
